import { Modify } from '@teinor/erp'
import {GroupPermissionsComputed} from '@teinor/erp/permissions'
import { EmployeeModelType } from '@teinor/erp/types/company/userInner/employee'
import { TwinEmployeeParametersDict } from '@teinor/erp/types/company/userInner/employeeParameter'
import { WorkingCenterModelType } from '@teinor/erp/types/company/workingCenter'
import { dictionaryComplexFromJsonArr, TwinDictionary } from '../../globals/dictionary'

export type UserLoginType = 'erp' | 'admin' | 'forQr'

export type UserCookie = {
    token: string
    type: UserLoginType
    remember?: boolean
    subType?: 'temporal' 
    changeMultiUser?: boolean
    dateLastChange?: string
}

export interface UserInfo extends UserCookie{
    extraData: UserModel
}
type WorkingCenterModelTypeExtended = WorkingCenterModelType & {
    is_default: boolean
    BillingGroupId: number
}
type WorkingCenters = {[key: string]: WorkingCenterModelTypeExtended}
export interface UserModel {
    id: number
    email: string
    name: string
    surname: string
    image: string | null
    is_admin: boolean
    active: boolean
    type: number
    isManager: boolean
    groupPermissions: GroupPermissionsComputed
    WindowId: string
    WorkingCenters?: WorkingCenters
    WorkingCenterId?: number
    Employee?: EmployeeModelType
    WorkingCenterStationId?: number
    validEmployees?: EmployeeModelType[]
}

type UserModelForPayload = Modify<UserInfo, {
    extraData: UserModel & {workingCenters?: WorkingCenterModelTypeExtended[]}
}>
export interface ChangeMultiUserAction {
    type: 'CHANGE_MULTI_USER'
    payload: boolean
}
export interface UserAction {
    type: 'CHANGE_USER'
    payload: UserModelForPayload | null
}
export interface UserActionWorkingCenter {
    type: 'CHANGE_USERWORKINGCENTER'
    payload: {WorkingCenterId?: number, WorkingCenterStationId?: number}
}
export interface EmployeeParamsActionWorkingCenter {
    type: 'CHANGE_EMPLOYEE_PARAMS'
    payload: TwinEmployeeParametersDict
}
export type UserPayload = UserInfo | null
type Actions = UserAction | UserActionWorkingCenter | EmployeeParamsActionWorkingCenter | ChangeMultiUserAction
export default function user(state: UserPayload = null, action: Actions) : UserPayload {
    switch (action.type) {
        case 'CHANGE_MULTI_USER':
            if(!state){
                return state
            }
            return state = {...state, changeMultiUser: action.payload, dateLastChange: new Date().toString()}
        case 'CHANGE_USER':
            let WorkingCenterId = undefined
            let WorkingCenterStationId = undefined
            const WorkingCenters: TwinDictionary = {}
            if (action.payload?.extraData?.Employee?.WorkingCenters && action.payload?.extraData?.Employee.defaultWorkingCenterId) {
                WorkingCenterId = action.payload?.extraData?.Employee.defaultWorkingCenterId
                WorkingCenterStationId = action.payload?.extraData?.Employee.defaultWorkingCenterStationId
                for (const element of action.payload?.extraData?.Employee?.WorkingCenters) {
                    WorkingCenters[element.id] = element
                }
            }
            let myWorkingCenterId = window.sessionStorage.getItem('WorkingCenterId') || '0'
            let myWorkingCenterStationId = window.sessionStorage.getItem('WorkingCenterStationId') || '0'
            if (!WorkingCenters?.[parseInt(myWorkingCenterId)]) {
                myWorkingCenterId = ''
                myWorkingCenterStationId = ''
            }
            return state = action.payload?.extraData ? { ...action.payload, extraData: { ...action.payload?.extraData, WorkingCenterId: parseInt(myWorkingCenterId) || WorkingCenterId, WorkingCenters: WorkingCenters, WorkingCenterStationId: parseInt(myWorkingCenterStationId) || WorkingCenterStationId } } : null
        case 'CHANGE_USERWORKINGCENTER':
            if (state) {
                const copy = JSON.parse(JSON.stringify(state))
                const dictWorkingCenters = dictionaryComplexFromJsonArr(copy?.extraData?.Employee?.WorkingCenters || [])
                const myWorkingCenterId = action.payload.WorkingCenterId || copy.extraData?.WorkingCenterId
                copy.extraData.WorkingCenterId = myWorkingCenterId
                copy.extraData.WorkingCenterStationId = action.payload.WorkingCenterStationId || dictWorkingCenters[myWorkingCenterId]?.WorkingCenterStations?.[0]?.id || 0
                window.sessionStorage.setItem('WorkingCenterId', String(myWorkingCenterId))
                window.sessionStorage.setItem('WorkingCenterStationId', String(copy.extraData.WorkingCenterStationId))
                return { ...copy }
            }
            return state
            case 'CHANGE_EMPLOYEE_PARAMS':
                if (state && state.extraData.Employee) {
                    const copy = JSON.parse(JSON.stringify(state))
                    copy.extraData.Employee.EmployeeParameters = { ...copy.extraData.Employee.EmployeeParameters, ...action.payload }
                    return { ...copy }
                }
                return state
            default:
                return state
    }
}